import {orderCartNameSelector} from '../../../data/orders.js'
import {useSelector} from '../../../store.js'

export default function OrderCart({orderNumber}) {
  const cartName = useSelector(
    (state) => orderCartNameSelector(state, {orderNumber}) || '',
  )

  return <span>{cartName}</span>
}
